export const sanitizeRaw = (input: string): string => {
	if (!input) return ''
	let s = input.replace(/[^0-9.,]/g, '')
	if (s.startsWith('.') || s.startsWith(',')) s = `0${s.replace('.', ',')}`
	s = s.replace(/\./g, ',')
	const parts = s.split(',')
	if (parts.length > 1) {
		const intPart = parts.shift() ?? ''
		const dec = parts.join('')
		s = `${intPart},${dec}`
	}
	const [i, d] = s.split(',')
	if (d !== undefined) s = `${i},${d.slice(0, 2)}`
	return s
}

export const toNumber = (str: string): number | null => {
	if (!str) return null
	const normalized = str.replace(/\u00A0|\s/g, '').replace(/,/g, '.')
	const n = Number(normalized)
	return Number.isFinite(n) ? n : null
}

export const formatDisplay = (str: string): string => {
	const n = toNumber(str)
	if (n === null) return ''
	return new Intl.NumberFormat('fr-FR', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
		currency: 'EUR',
		style: 'currency'
	}).format(n)
}

export const formatAmount = (amount: number): string => {
	return amount.toFixed(2).replace('.', ',')
}
